/**
 * Endpoint del catálogo ANMAT — read-only.
 */

import { GetEventosAnmatResponse, type EventoAnmat } from '@/api/contracts/eventos-anmat';
import { getDb } from '@/api/mock/db';

const MOCK_LATENCY_MS = 60;
function delay(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

/** GET /api/eventos-anmat — catálogo completo (en producción podría paginarse). */
export async function getEventosAnmat(): Promise<EventoAnmat[]> {
  await delay(MOCK_LATENCY_MS);
  return GetEventosAnmatResponse.parse(getDb().eventosAnmat);
}
